// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
   
  }
  
  .form-wrapper {
    width: 100%;
    max-width: 600px;
    background-color: #fff;
    margin-top: 20px;
    
    border-radius: 10px;
    padding: 20px;
  }
  
  .datetime {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
  }
  
  .datetime-section {
    display: flex;
    flex-direction: column;
  }
  
  .datetime-section label {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .form-content {
    display: flex;
    flex-direction: column;
  }
  
  .input-wrapper {
    margin-bottom: 2px;
  }
  
  .input-wrapper label {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .input-wrapper input,
  .input-wrapper textarea,
  .input-wrapper select {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
  }
  .input-wrapper textarea{
    resize: none;
  }
  
  
  .button-col {
    display: flex;
    justify-content: flex-end;
  }
  
  .msg button {
    padding: 8px 10px;
    background-color: orange;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  
  
  `, "",{"version":3,"sources":["webpack://./src/components/notification.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;;EAEd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;;IAEhB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;;IAGE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,YAAY;EACd;;;EAGA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n   \n  }\n  \n  .form-wrapper {\n    width: 100%;\n    max-width: 600px;\n    background-color: #fff;\n    margin-top: 20px;\n    \n    border-radius: 10px;\n    padding: 20px;\n  }\n  \n  .datetime {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n  }\n  \n  .datetime-section {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .datetime-section label {\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n  \n  .form-content {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .input-wrapper {\n    margin-bottom: 2px;\n  }\n  \n  .input-wrapper label {\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n  \n  .input-wrapper input,\n  .input-wrapper textarea,\n  .input-wrapper select {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 14px;\n  }\n  .input-wrapper textarea{\n    resize: none;\n  }\n  \n  \n  .button-col {\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .msg button {\n    padding: 8px 10px;\n    background-color: orange;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
